import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { PedidoDRPViewModule } from '../pedido';
import { PedidoItemDRPViewModule } from '../item';

import { DRPViewComponent } from './drp-view.component';

@NgModule({
    imports: [
        SharedModule,
        PedidoDRPViewModule,
        PedidoItemDRPViewModule
    ],
    declarations: [
        DRPViewComponent
    ],
    exports: [
        DRPViewComponent
    ]
})
export class DRPViewModule { }
